import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { PersonModel } from '../../person/models/person.model';
import { DriverModel } from '../models/driver.model';
import { DriverService } from '../models/driver.service';

@Component({
  selector: 'wego-add-driver-popup',
  template: require('../views/add-driver-popup.component.html'),
})

export class AddDriverPopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  personList: PersonModel[];
  model: DriverModel;
  message: string;
  validationMessage: string;
  apiErrorMsg: string;
  urlPersonUpdate: string;
  isLoading: boolean;

  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('driverModal') public driverModal: any;
  @ViewChild('successPopup') public successPopup: any;

  constructor(private driverService: DriverService
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) { }

  ngOnInit() {
    this.module = this.translate.instant('LblDriver');
    this.breadCrumbTitle = this.translate.instant('LblAddPage', [this.module]);
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["userName", "firstName", "lastName"];
    this.urlPersonUpdate = this.authService.GetURL(ApplicationRouteURL.URL_PERSON_UPDATE);
    this.model = new DriverModel();
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetPersonListForDrivers();
    this.driverModal.show();
    this.validationMessage = '';
  }

  public hide(): void {
    this.driverModal.hide();

  }

  private GetPersonListForDrivers() {
    this.isLoading = true;
    this.driverService.GetPersonListForDrivers(this.DataListModel)
      .subscribe(
      res => {
        this.personList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private select(personMasterHashId: string): void {
    this.isLoading = true;
    this.model.personMasterHashId = personMasterHashId;
    this.model.isBanned = true;
    this.driverService.AddNewDriver(this.model)
      .subscribe(
      res => {
        this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]);//this.translate.instant('LblRecordSavedSuccess');
        this.OnSuccessSelect();
        this.isLoading = false;
        //this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        this.driverModal.hide();
        this.isLoading = false;
      });
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetPersonListForDrivers();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetPersonListForDrivers();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetPersonListForDrivers();
  };
  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetPersonListForDrivers();
  }

  private OnSuccessSelect() {
    this.onSuccessSelect.emit({ SuccessMessage: this.popupMsg })
  }


  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/driver/components/add-driver-popup.component.ts